import { Rescatable } from '../Rescatable';
import { Product } from './Product';

export class Brand extends Rescatable {
  static _name = 'Brand';
  static pathRequest = Rescatable.pathRequestStatic + 'marcas';
  static pk: keyof Brand = 'id';
  id: number;
  nombre: string;
  garantia_datos: number;
  garantia_meses_por_defecto: number;
  garantia_meses_propia: number;
  garantia_oficial: number;
  marca_nombre_alias: string;
  marca_nombre_no_ponderado: string;
  $products: Product[];
  constructor(brand: Brand) {
    super(brand);
  }
}
